<template>
  <div style="height:100%;">
    <div class="table-box">
      <div class="right-title">主体信息</div>
      <div class="company-detail">
        <div class="right">
          <div>
            <div class="title">{{ form.firmName }}</div>
            <div class="table-box">
              <div style="border-bottom: 2px solid rgba(39, 245, 255, 0.05);font-size: 0.1rem">
                <div style="margin: 0.1rem">
                  <span>法定代表人:</span>
                  <span>大拿</span>
                </div>
                <div class="table-row">
                  <div class="table-col">
                    <span>电话:</span>
                    <span>{{ form.telephone }}</span>
                  </div>
                  <div class="table-col">
                    <span>邮箱:</span>
                    <span>{{ form.email }}</span>
                  </div>
                </div>
                <div class="table-row">
                  <div class="table-col">
                    <span>网址:</span>
                    <span>{{ form.email }}</span>
                  </div>
                  <div class="table-col">
                    <span>地址:</span>
                    <span>{{ form.address }}</span>
                  </div>
                </div>
              </div>
              <div class="company-desc">
                <div class="desc-title">企业概况</div>
                <div class="desc-content" v-html="form.firmIntroduce"></div>
                <div class="desc-title">运营状况</div>
                <div class="desc-content">{{ form.businessCondition }}</div>
                <div class="desc-title">风险概览</div>
                <div class="desc-content">{{ form.engageRisk }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  }
};
</script>

<style scoped lang="scss">
.table-box {
  border: 1px solid #01c5f3;
  padding:0 0.05rem;
  height: 100%;
  .right-title {
    border-left: 2px solid #01c5f3;
    padding: 0 0.1rem;
    font-size: 0.12rem;
    font-weight: 550;
    margin-top: 0.05rem;
  }
  .company-detail {
    display: flex;
    font-size: 0.15rem;
    margin-top: 0.1rem;
    .left {
      width: 10%;
      font-size: 0.45rem;
      height: 1.3rem;
      background: #2897e4;
      color: #fff;
      text-align: center;
    }
    .right {
      width: 100%;
      margin: 0 0.1rem;
      color: #fff;

      .title {
        font-size: 0.12rem;
        margin-bottom: 0.1rem;
      }
      .table-row {
        display: flex;
        align-items: center;
        .table-col {
          width: 50%;
          margin: 0.1rem;
        }
      }
    }
  }
  .company-desc{
    .desc-title{
        padding: 0.1rem ;
        font-weight: 600;
      font-size: 0.1rem
    }
    .desc-content{
        padding: 0.1rem ;
      font-size: 0.1rem
    }
  }
}
</style>
